import '../scss/app.scss'; // Importing SCSS file

import manage_flight_track_data from './functions/manage_flight_track_data'; // Importing the manage_flight_track_data function from the specified file

class Fly_Knoxville_GP {
  constructor() {
    this.clickListeners = []; // Array to store click listeners
    this.manage_flight_class = new manage_flight_track_data(this, flight_data); // Creating an instance of the manage_flight_track_data class
  }

  init() {
    this.manage_flight_class.init(); // Initializing the manage_flight_class
    this.events(); // Calling the events method
  }

  events() {
    // Loop through click listeners and add event listeners
    this.clickListeners.forEach((listener) => {
      listener.element.addEventListener(listener.event, listener.function);
    });
  }
}

let fly_knoxville_gp = new Fly_Knoxville_GP(); // Creating an instance of the Fly_Knoxville_GP class
fly_knoxville_gp.init(); // Calling the init method

console.log('flights');